import _Api from '@/api/_Api';

import { GetFilesInterface } from '@/interfaces/Bookings';
import { downloadBlob } from 'download.js';

export class FilesApi extends _Api {
   static async get(id: number, table: string | null = null): Promise<GetFilesInterface> {
      const response = await this.http().get(`files/${id}`, { params: { table } });
      return response.data;
   }

   static async download(id: number, file_id: number, table: string | null = null) {
      const response = await this.http().get(`files/${id}`, { responseType: 'blob', params: { file_id, table } });

      const disposition = response.headers['content-disposition'];
      let filename = 'downloaded.file';

      console.log(response.headers);

      if (disposition && disposition.includes('filename=')) {
         const match = disposition.match(/filename[^;=\n]*=(['"]?)([^'"\n]*)\1?/);
         if (match && match[2]) {
            filename = decodeURIComponent(match[2]);
         }
      }

      downloadBlob(filename, response.data);
   }

   static async upload(id: number, files: File[], table: string | null = null): Promise<any> {
      const config = { headers: { 'Content-Type': 'multipart/form-data' }, params: { table } };
      const $form = new FormData();

      files.forEach((file: File) => {
         $form.append('files[]', file);
      });

      const response = await this.http().post(`files/${id}`, $form, config);
      return response.data;
   }

   static async delete(id: number, file_id: number, table: string | null = null): Promise<any> {
      const response = await this.http().delete(`files/${id}`, { params: { file_id, table } });
      return response.data;
   }
}
